export function getServerUrl(url) {
  
  if (
    typeof url === 'string'
    && url.length
  ) {
    return url;
  } else if (process.env.NODE_ENV === 'production') {
    return '/';
  } else if (
    ['127.0.0.1', 'localhost'].includes(window.location.hostname)
   ) {
    return `https://${window.location.hostname}:8081/`;
  } else if (
    window.location.origin.includes('playpauseit')
  ) {
    const split = window.location.hostname.split('.');
    const name = (split[0].substr(0, 3) === 'api') ? split[0].substr(3) : split[0].substr(2);
    return `https://api${name}.playpauseit.com/`;
  } else {
    return '/';
  }
}